import React from "react";
import "./Winery.scss";

const Winery = () => {
  return (
    <main>
      <div className="winery-header">
      </div>

      <article className="winery-container">
        <img src="/images/winery-temp.png" alt="winery-bottle"></img>
        <div className="winery-content">
          <p>
            Sprawling vineyards in picturesque, verdant surrounds offering tours,
            tastings & light fare in beautiful Niagara-on-the-Lake. Paul Bosc, a
            fifth-generation French winegrower, founded{" "}
            <a
              className="link"
              href="https://www.chateaudescharmes.com/"
              target="_blank"
            >
              Château des Charmes
            </a>{" "}
            in 1978. Paul Bosc and his young family arrived in Niagara in the
            1960’s with the idea that growing our own grapes was the best way to
            make fine wine. More than ever, they believe in this Estate Winery
            model and make their wine only from grapes they’ve grown themselves.
            Paul and his young family arrived in Niagara in the 1960’s with the
            idea that growing our own grapes was the best way to make fine wine.
            More than ever, we believe in this Estate Winery model and we make our
            wine only from grapes we’ve grown ourselves. We believe we are
            custodians of the land.
          </p>
          <br/>
          <p>
            From the beginning we have been committed to using sustainable
            practices and are charter members of Sustainable Winegrowing
            Ontario. And with more than 40 vintages in our vineyards we think we
            now know which varieties grow best in which spot. But there is always
            more to learn. We believe our groundbreaking research with unique
            grape varieties will blaze a trail to the future of our industry. The
            Bosc family remain committed to owning and operating Château des
            Charmes and producing 100% estate-grown wines. Paul’s vision of a
            world class Niagara wine industry led by high quality estate wineries
            has reached fruition. Today, the vibrant Ontario industry boasts more
            than 175 wineries, employs more than 6000 people and receives
            approximately 1.8 million visitors each year.
          </p>
        </div>
      </article>
    </main>
  );
};

export default Winery;
